import cx from "classnames";
import React, { CSSProperties } from "react";
import styles from "./title.module.scss";

export interface ITitle {
  children?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Title = (props: ITitle) => {
  return (
    <div className={cx(styles.title, props.className)} style={props.style} id={props.htmlId}>
      <h3>{props.children}</h3>
      <div className={styles.actions}>{props.actions}</div>
    </div>
  );
};

Title.defaultProps = {};
